import { Theme } from '@mui/material';
import { SxProps } from '@mui/system';
import ThemeConstants from '../../../theme/ThemeConstants';

const styles = {
  container: {
    paddingX: '24px',
    paddingBottom: '20px',
  },
  title: {
    color: ThemeConstants.grey[800],
    fontSize: '16px',
    fontWeight: '600',
    marginBottom: '10px',
  },
  checkboxLabel: {
    fontSize: 14,
  },
  horizontalField: {
    '& fieldset': { border: 'none' },
    '& label': {
      flex: 2,
      marginBottom: 3,
    },
    '& .MuiTextField-root': {
      flex: 1,
    },
  },
  timeContainer: {
    display: 'flex',
    gap: '30px',
    marginBottom: '24px',
  },

  timeDurationsContainer: {
    display: 'flex',
    flexDirection: 'column',
  },

  dateContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    gap: '10px',
  },

  field: {
    flex: 2,
  },

  select: {
    mt: '3px',
    flex: 1,
  },

  dateBoxGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2,1fr)',
    columnGap: '10px',
  },

  selectButton: {
    borderRadius: '9px',
  },

  durationInfo: {
    display: 'flex',
    alignItems: 'center',
    color: 'common.counterRed',
    fontSize: 12,
    my: '5px',
  },

  selectedDuration: {
    display: 'flex',
    alignItems: 'center',
    color: 'primary.main',
    fontSize: 12,
    fontWeight: '500',
    my: '5px',
  },

  modalContainer: {
    backgroundColor: 'common.lightBackgroundColor',
  },
  subContainer: {
    display: 'flex',
    paddingX: '41px',
    paddingY: '24px',
  },

  globalTimeContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: 'secondary.main',
    padding: '12px',
    borderRadius: '9px',
    mb: '16px',
    mt: { xs: 2, md: 0 },
  },
  noteContainer: {
    marginRight: '10px',
  },

  note: {
    fontSize: 12,
    color: 'grey.800',
  },

  subTitle: {
    fontSize: 14,
    color: 'grey.800',
    fontWeight: '400',
    marginBottom: '-7px',
    whiteSpace: 'nowrap',
  },

  buttonContainer: {
    gap: '15px',
    flex: 1,
    position: 'sticky',
    bottom: 0,
    width: '100%',
    paddingY: '16px',
    backgroundColor: 'common.lightBackgroundColor',
    justifyContent: 'flex-end',
    boxShadow: '0px -2px 4px 0px #0000000A',
  },
  saveButton: { marginRight: '47px' },
  promoLabel: {
    color: 'common.counterRed',
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
